export class Coord {
  constructor(obj) {
    this.lat = obj.latitude
    this.lng = obj.longitude
  }
}
